import { createSlice } from '@reduxjs/toolkit';

const loadCart = () => {
  try { return JSON.parse(localStorage.getItem('cart')) || []; } catch { return []; }
};

const saveCart = (items) => {
  try { localStorage.setItem('cart', JSON.stringify(items)); } catch {}
};

const cartSlice = createSlice({
  name: 'cart',
  initialState: { items: loadCart() },
  reducers: {
    addToCart(state, { payload }) {
      const existing = state.items.find(i =>
        i.id === payload.id && i.selectedSize === payload.selectedSize && i.selectedColor === payload.selectedColor
      );
      if (existing) {
        existing.quantity += payload.quantity || 1;
      } else {
        state.items.push({ ...payload, cartId: `${payload.id}-${payload.selectedSize}-${Date.now()}` });
      }
      saveCart(state.items);
    },
    removeFromCart(state, { payload: cartId }) {
      state.items = state.items.filter(i => i.cartId !== cartId);
      saveCart(state.items);
    },
    updateQuantity(state, { payload: { cartId, quantity } }) {
      const item = state.items.find(i => i.cartId === cartId);
      if (item) { item.quantity = quantity; saveCart(state.items); }
    },
    updateSize(state, { payload: { cartId, size } }) {
      const item = state.items.find(i => i.cartId === cartId);
      if (item) { item.selectedSize = size; saveCart(state.items); }
    },
    clearCart(state) {
      state.items = [];
      localStorage.removeItem('cart');
    },
  },
});

export const { addToCart, removeFromCart, updateQuantity, updateSize, clearCart } = cartSlice.actions;
export default cartSlice.reducer;
